import { useContext } from 'react'
import { ApplicationContext } from '../Providers/ApplicationProvider'

/**
 * Hook personnalisé pour accéder aux fonctionnalités d'authentification
 * @returns {Object} Objet contenant le token, l'état d'authentification, et les méthodes de gestion
 */
export const useAuth = () => {
  const context = useContext(ApplicationContext)

  if (!context) {
    throw new Error('useAuth doit être utilisé dans un ApplicationProvider')
  }

  return context
}
